import React from 'react';
import Search from '@kyruus/react-ikons/Search';
import { FormattedMessage } from '@kyruus/intl';
import { StyledSearchAreaButton } from './styles';
import { messages } from './messages';

export const SearchAreaButton = ({ onClick }) => {
  const handleSearchArea = () => {
    if (onClick) {
      onClick();
    }
  };

  return (
    <StyledSearchAreaButton
      mode="ghost"
      active={true}
      icon={<Search size="1.2em" />}
      iconAlign="left"
      onClick={handleSearchArea}
      data-testid="search-area-button"
    >
      <FormattedMessage {...messages.searchArea} />
    </StyledSearchAreaButton>
  );
};
